// Chart constants
export const TEXT_COLOR = '#000000';
export const BAR_HEIGHT = 16;
export const SPACE_BETWEEN_GROUPS = 15;
export const TEXT_HEIGHT = 10;
export const AXIS_HEIGHT = 20;
export const GROUP_HEIGHT = BAR_HEIGHT + SPACE_BETWEEN_GROUPS + TEXT_HEIGHT;
